import { render, staticRenderFns } from "./table-paginator.vue?vue&type=template&id=89b91a82&"
import script from "./table-paginator.vue?vue&type=script&lang=js&"
export * from "./table-paginator.vue?vue&type=script&lang=js&"
import style0 from "./table-paginator.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports